<template>
    <path fill-rule="evenodd"
          d="M26.265 21.58c-5.535 5.475-14.543 5.479-20.079 0a13.87 13.87 0 0 1-4.153-9.933c0-3.757 1.476-7.284 4.151-9.931a.999.999 0 0 0 0-1.422 1.025 1.025 0 0 0-1.437 0A15.855 15.855 0 0 0 0 11.647c0 4.294 1.687 8.328 4.747 11.355 2.584 2.558 5.832 4.053 9.2 4.521v2.466H10.9c-.562 0-1.017.45-1.017 1.005 0 .556.455 1.006 1.017 1.006h8.131c.561 0 1.017-.45 1.017-1.006 0-.555-.456-1.005-1.017-1.005h-3.05v-2.3c.082.001.163.011.245.011 4.155 0 8.312-1.565 11.478-4.696a.999.999 0 0 0 0-1.422 1.025 1.025 0 0 0-1.438-.002zM16.5 0C10.148 0 5 5.15 5 11.5S10.15 23 16.5 23 28 17.852 28 11.5 22.85 0 16.5 0zm0 21C11.261 21 7 16.739 7 11.5S11.261 2 16.5 2 26 6.261 26 11.5 21.739 21 16.5 21z"/>
</template>

<script>
export default {
    name: 'countryIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 28 32');
    }
};
</script>
